import { render } from "./CloseSideMenuBtn.vue?vue&type=template&id=087ea030"
import script from "./CloseSideMenuBtn.vue?vue&type=script&lang=js"
export * from "./CloseSideMenuBtn.vue?vue&type=script&lang=js"

import "./CloseSideMenuBtn.vue?vue&type=style&index=0&id=087ea030&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__